module.exports = __webpack_public_path__ + "static/media/man-cuts-layers-fabric-clothing-260nw-1722120523 (1).a1d5e666.jpg";